import { render, staticRenderFns } from "./IndustryAccountPage.vue?vue&type=template&id=808e8016&scoped=true"
import script from "./IndustryAccountPage.vue?vue&type=script&lang=js"
export * from "./IndustryAccountPage.vue?vue&type=script&lang=js"
import style0 from "./IndustryAccountPage.vue?vue&type=style&index=0&id=808e8016&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e8016",
  null
  
)

export default component.exports